<template>
  <v-card class="elevation-1 mb-6">
    <v-card-title class="pa-7">
      Ceník
      <v-spacer></v-spacer>
      <v-btn
        type="submit"
        height="40px"
        min-width="130px"
        color="primary"
        depressed
        @click="openNewPriceDialog"
      >
        Nový ceník
      </v-btn>
    </v-card-title>
    <v-card-text>
      <ProductPricesFilters @filter="setFiltersAction" />

      <v-data-table
        :headers="userHeadersByRole"
        :items="product.items"
        :options.sync="product.options"
        :server-items-length="product.serverItemsLength"
        :loading="product.loading"
        item-key="id"
        class="elevation-0"
      >
        <template v-slot:item.validSince="{ item }">
          <DateTime :disable-time="true" :datetime="item.validSince" />
        </template>
        <template v-slot:item.createdAt="{ item }">
          <DateTime :disable-time="false" :datetime="item.createdAt" />
        </template>
        <template v-slot:item.updatedAt="{ item }">
          <DateTime :disable-time="false" :datetime="item.updatedAt" />
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn-toggle color="primary" dense group>
            <v-btn color="blue-grey" text @click="openEditPriceDialog(item.id)">
              <v-icon>mdi-pencil-outline</v-icon>
            </v-btn>
            <v-btn color="blue-grey" text @click="removePrice(item.id, item.validSince)">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </v-btn-toggle>
        </template>
      </v-data-table>
    </v-card-text>
    <SupplierGasProductPricesAddDialog @priceCreated="loadProductPrices" />
    <SupplierGasProductPricesEditDialog @priceCreated="loadProductPrices" />
  </v-card>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { setFilters } from '@/components/mixins/setFilters'
import DateTime from '../DateTime'
import ProductPricesFilters from '../filters/ProductPricesFilters'
import SupplierGasProductPricesAddDialog from './SupplierGasProductPricesAddDialog'
import SupplierGasProductPricesEditDialog from './SupplierGasProductPricesEditDialog'

export default {
  name: 'SupplierGasProductPrices',
  components: {
    SupplierGasProductPricesEditDialog,
    SupplierGasProductPricesAddDialog,
    ProductPricesFilters,
    DateTime,
  },
  mixins: [setFilters],
  data() {
    return {
      product: {
        headers: [
          {
            text: 'Id',
            value: 'id',
            roles: ['ROLE_ADMIN'],
            width: '100px',
          },
          {
            text: 'Distributor',
            value: 'distributor.name',
            roles: ['ROLE_ADMIN'],
          },
          {
            text: 'Rozsah',
            value: 'consumptionRange.range',
            roles: ['ROLE_ADMIN'],
          },
          {
            text: 'Cena',
            value: 'price',
            roles: ['ROLE_ADMIN'],
          },
          {
            text: 'Cena SP',
            value: 'priceFixedSalary',
            roles: ['ROLE_ADMIN'],
          },
          {
            text: 'Platnost od',
            value: 'validSince',
            roles: ['ROLE_ADMIN'],
          },
          {
            text: 'Vytvořeno',
            value: 'createdAt',
            roles: ['ROLE_ADMIN'],
          },
          {
            text: 'Změněno',
            value: 'updatedAt',
            roles: ['ROLE_ADMIN'],
          },
          {
            text: 'Zdroj',
            value: 'source.text',
            roles: ['ROLE_ADMIN'],
          },
          {
            text: '',
            value: 'actions',
            width: '1px',
            sortable: false,
            roles: ['ROLE_ADMIN'],
          },
        ],
        items: [],
        options: {
          page: 1,
          itemsPerPage: 14,
          sortBy: ['id'],
          sortDesc: [true],
        },
        loading: false,
        serverItemsLength: 0,
      },
      productFooter: {
        totalElements: 0,
        selectedData: {
          params: {},
          items: [],
        },
      },
      cancel: null,
    }
  },
  computed: {
    ...mapState({
      authorities: (state) => state.auth.user.authorities,
    }),
    userHeadersByRole() {
      return this.product.headers.filter((e) => e.roles.some((e) => this.authorities.includes(e)))
    },
  },
  watch: {
    'product.options': {
      handler() {
        this.loadProductPrices()
      },
    },
    '$route.query': {
      handler() {
        this.loadProductPrices()
      },
    },
    'product.selected': {
      handler() {
        this.productFooter.selectedData.items = this.product.selected
      },
    },
  },
  methods: {
    ...mapActions({
      searchSupplierProductPrices: 'supplier/searchSupplierProductPrices',
      deleteSupplierProductPrice: 'supplier/deleteSupplierProductPrice',
    }),
    loadProductPrices() {
      this.product.loading = true
      const searchParams = {
        filterParams: this.$route.query,
        options: this.product.options,
      }
      this.productFooter.selectedData.params = searchParams
      this.searchSupplierProductPrices({
        supplierId: this.$route.params.supplierId,
        productId: this.$route.params.productId,
        type: this.$route.params.type,
        params: searchParams,
      })
        .then((response) => {
          this.productFooter.totalElements = response.data.totalElements
          this.product.items = response.data.items
          this.product.serverItemsLength = response.data.totalElements
          this.cancel = null
        })
        .finally(() => {
          this.product.loading = false
        })
    },
    setFiltersAction(filters) {
      this.product.options.page = 1
      this.setFilters(filters)
    },
    removePrice(id, validSince) {
      this.$confirm(
        'Budou smazána všechna data ceníku s datem platnosti od ' +
          this.$dayjs(validSince).format('D.M.YYYY'),
        {
          title: 'Smazat ceník?',
          buttonTrueText: 'Ano',
          buttonFalseText: 'Ne',
          icon: '',
          color: 'black',
        }
      ).then((result) => {
        if (result) {
          this.product.loading = true
          this.deleteSupplierProductPrice({
            supplierId: this.$route.params.supplierId,
            productId: this.$route.params.productId,
            type: this.$route.params.type,
            priceId: id,
          })
            .then(() => {
              this.loadProductPrices()
            })
            .finally(() => {
              this.product.loading = false
            })
        }
      })
    },
    openNewPriceDialog() {
      this.$eventBus.$emit('supplierGasProductPricesAddDialog', true)
    },
    openEditPriceDialog(id) {
      this.$eventBus.$emit('supplierGasProductPricesEditDialog', true, id)
    },
  },
}
</script>
